import styled, { css } from 'styled-components'
import { Heading, HeadingLevel, Text, TextLevel } from '@lmc/ui-kit/src/general'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const requiredContent = css`
  &:after {
    content: ' *';
    color: #ff0000;
  }
`

const Title = styled(Heading)<{ required?: boolean }>`
  ${({ required }) => required && requiredContent}
  margin-bottom: 4px;
`

const Description = styled(Text)`
  margin-bottom: 10px;
  color: ${({ theme }) => theme.color.neutral.color4};
`

const CategoryInfo = (props: CategoryInfoProps) => {
  const {
    children,
    title,
    description,
    required,
    className,
    titleLevel = 4,
    descriptionLevel = 2,
  } = props

  return (
    <Wrapper className={className}>
      {title && (
        <Title required={required} level={titleLevel}>
          {title}
        </Title>
      )}
      {description && (
        <Description level={descriptionLevel}>{description}</Description>
      )}
      {children}
    </Wrapper>
  )
}

export interface CategoryInfoProps {
  title?: React.ReactNode
  required?: boolean
  children: React.ReactNode
  description?: string
  className?: string
  titleLevel?: HeadingLevel
  descriptionLevel?: TextLevel
}

export default CategoryInfo
